import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Panel, PageHeader, ListGroup, ListGroupItem, Button
} from 'react-bootstrap';
import LoggedinUser from '../../models/LoggedinUser';
import Footer from '../../components/footer/Footer';
import { getNoBrand } from '../../index';

//css
const subscriptionsStyle = require('./subscriptions.css');


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class Subscriptions extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  render() {

    const imageStyle = {
      width: '100%',
      height: 'auto',
      background: 'cover'
    };

    const noBrand = getNoBrand();
    const imgPageBanner = require('../../images/imageBannerBlue1000x120.png');
    const subscrName = noBrand ? ('Din mobil') : (this.props.loggedinUser.subscriptions.selectedSubscription.name);

    // We need to check that we have subscriptions
    if (this.props.loggedinUser.subscriptions.items.length === 0) {
      return (
        <div>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="pageBanner">
                  <h2>Abonnemang</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="pageBanner">
                  <h2>Abonnemang</h2>
                </div>
              </div>
            </div>

            <div className="subscriptionNameAndNumber">{subscrName} - {this.props.loggedinUser.subscriptions.selectedSubscription.number}</div>

            {/* the grid with all icons and text about the account */}
            <div className="subscr_grid">
              <div className="subscr_details_box">
              { noBrand ? (
                <h6>Med ditt abonnemang kan du ringa inom landet, skicka SMS och MMS och surfa.</h6>
              ) : (
                <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.properties.description}</h6>
              )}
              { noBrand ? (
                <h6>Abonnemang finns med flera olika surfpaket - välj din nivå av surf.</h6>
              ) : (
                <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.properties.extra1}</h6>
              )}
              { noBrand ? (
                <h6>Samtal till utlandet samt betalsamtal ingår inte i abonnemanget.</h6>
              ) : (
                <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.properties.extra2}</h6>
              )}
              </div>
              <div className="subscr_PUKcode_box">
                <h6 className="subscr_PUKcode">PUK-kod</h6>
                {/* <h6>123 45 67</h6> */}
                <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.properties.PUKcode}</h6>
              </div>
              {/* <div className="subscr_SIMcard_box">
            <h6 className="subscr_SIMcard">SIM-kortsnummer</h6>           
            <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.properties.SIMcardNumber}</h6>
          </div> */}
              {/* <div className="subscr_period_box">
            <h6 className="subscr_period" >Bindningstid</h6>
            <h6>26 januari 2020</h6>
          </div> */}
            </div>
            <div className="subscr_button_grid">
              <div className="subscr_button_box">
              </div>
            </div>
          </div>
          <div className="footerDiv">
            <Footer loggedinUser={this.props.loggedinUser} />
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/subscriptions/Subscriptions.tsx